import { httpClient } from './config';
import { ServerResponse } from './types';

export const brandEssentials = (brandDomain: string) => httpClient.get<any, ServerResponse>('/api/brand_essentials', {
  headers: {
    'host-url': brandDomain,
  },
});
